// 不同路由使用同一个组件，导致组件在路由动态加载的时候进行重复设名，keep-alive失效
// 在这里列出重复的组件，动态设置组件名的时候同意设置成一个
export const nameMap = {
  RoleDetail: 'RoleEdit', // 角色详情->角色编辑
  RoleAdd: 'RoleEdit', // 角色新增->角色编辑
  AccountAdd: 'AccountEdit' // 账户新增->账户编辑
}
